/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowDownTail = createReactComponent("arrow-down-tail", "IconArrowDownTail", [
  ["path", { d: "M12 6v15", key: "svg-0" }],
  ["path", { d: "M9 18l3 3l3 -3", key: "svg-1" }],
  ["path", { d: "M9 3l3 3l3 -3", key: "svg-2" }]
]);

export { IconArrowDownTail as default };
//# sourceMappingURL=IconArrowDownTail.js.map
